import React from 'react';
import HomeManagementComponent from '../../../components/admin/home/HomeManagementComponent';

const HomeManagement: React.FC = () => {
  return <HomeManagementComponent />;
};

export default HomeManagement;
